const STATUS_FINANCEIROS: {[status: string]: string} = {
  CREATED: 'Preparando cobrança',
  SENT: 'Aguardando no terminal',
  APPROVED: 'Aprovado',
  REJECTED: 'Rejeitado',
  ERROR: 'Erro no pagamento',
  INDETERMINATE: 'Resultado indefinido',
  REVERSED: 'Estornado',
  REVERSAL_PENDING: 'Estorno pendente',
  REVERSAL_REJECTED: 'Estorno rejeitado',
};

const STATUS_FISCAIS: {[status: string]: string} = {
  NOT_APPLICABLE: 'Sem integração fiscal',
  NOT_READY: 'Aguardando processamento fiscal',
  READY: 'Aguardando envio da NFC-e',
  GENERATED: 'NFC-e gerada',
  AUTHORIZED: 'NFC-e autorizada',
  FISCAL_ERROR: 'Pendência fiscal',
  BLOCKED_ACQUIRER_MAPPING: 'Adquirente sem configuração fiscal',
};

const TIPOS_POR_METODO: {[metodo: string]: number} = {
  CREDITO: 10,
  DEBITO: 20,
  PIX: 30,
  VOUCHER: 60,
  OUTRO: 99,
};

const MODALIDADES_POR_METODO: {[metodo: string]: string} = {
  CREDITO: 'Crédito à vista',
  DEBITO: 'Débito à vista',
  PIX: 'Pix',
  VOUCHER: 'Voucher',
  OUTRO: 'Pagamento à vista',
};

export function rotuloStatusFinanceiroConnectTef(status: string): string {
  return STATUS_FINANCEIROS[String(status || '').toUpperCase()] || status || '—';
}

export function rotuloStatusFiscalConnectTef(status: string): string {
  return STATUS_FISCAIS[String(status || '').toUpperCase()] || status || '—';
}

export function tipoConnectTefPorMetodo(metodo: string): number {
  return TIPOS_POR_METODO[String(metodo || '').toUpperCase()] || 99;
}

export function rotuloModalidadeConnectTef(metodo: string): string {
  return MODALIDADES_POR_METODO[String(metodo || '').toUpperCase()] || 'Pagamento à vista';
}

export function rotuloModoOperacaoConnectTef(modoOperacao: string): string {
  return modoOperacao === 'EMULADOR_LOCAL' ? 'Emulador local' : 'Smart física';
}

export function mensagemVinculacaoConnectTef(vinculacao: any): string {
  if(vinculacao && vinculacao.modoOperacao === 'EMULADOR_LOCAL')
    return 'Emulador local detectado e disponibilizado.';
  return vinculacao && vinculacao.qrCode ?
    'QR gerado. Aguarde a confirmação da Smart física.' :
    'Solicitação enviada. Aguarde a confirmação da Smart física.';
}

export function terminalConnectTefFaturavel(terminal: any): boolean {
  return !!terminal && terminal.ambiente === 'PRODUCAO' && !!terminal.uuidTerminal &&
    terminal.ativo === true && terminal.statusVinculo === 'LINKED' &&
    terminal.modoOperacao !== 'EMULADOR_LOCAL' && !terminal.desativadoEm;
}
